export class Switch {

    constructor($ele) {

        // Selektor-String
        if(typeof $ele !== "object")
            $ele = document.querySelector($ele);

        // Elemente
        this.$ele = $ele;
        this.$input = this.$ele.querySelector("input[type=hidden]");
        this.$container = this.$ele.closest(".switch-container");
        this.showIfOn = [];
        this.showIfOff = [];
        if(this.$container) {
            this.showIfOn = this.$container.querySelectorAll(".show-if-on");
            this.showIfOff = this.$container.querySelectorAll(".show-if-off");
        }

        // Event für Change
        this.eventChange = new CustomEvent('change', { detail: { switch: this } });

        // Acquisition
        this.#acquisition();

        // Klick-Aktion
        this.$ele.addEventListener('click', event => {
            event.preventDefault();
            this.toggle();
        });
    }

    isActivated() {
        return this.$ele.getAttribute("aria-checked")==="true" ? true : false;
    }

    #acquisition() {

        // Anzeigebereiche ein- und ausblenden
        if(this.showIfOn) {
            this.showIfOn.forEach($e => {
                if(this.isActivated()) {
                    $e.classList.remove('hidden');
                } else {
                    $e.classList.add('hidden');
                }
            });
        }
        if(this.showIfOff) {
            this.showIfOff.forEach($e => {
                if(this.isActivated()) {
                    $e.classList.add('hidden');
                } else {
                    $e.classList.remove('hidden');
                }
            });
        }

        // Wert bei Input setzen
        if(this.$input) {
            this.$input.value = this.isActivated();
        }
    }

    toggle() {
        this.$ele.setAttribute("aria-checked", this.isActivated()?false:true);
        this.#acquisition();
        this.$ele.dispatchEvent( this.eventChange );
    }

    undo() {
        this.$ele.setAttribute("aria-checked", this.isActivated()?false:true);
        this.#acquisition();
    }
}